<template>
  <section class="admin-content " id="contact-search">
    <main class="admin-main">
       <div class="bg-dark m-b-30">
           <div class="container">
               <div class="row p-b-10 p-t-10">

                   <div class="col-md-6 text-center mx-auto text-white p-b-30">

                       <h3 class="h3">Health Facility Registration {{register.localgovt}}</h3>

                   </div>


               </div>
           </div>
       </div>
       <section class="">
           <div class="container">

               <div class="row list">


                   <div class="col-md-12">
                     <div class="card m-b-30">
                       <div class="card-body">

                         <div class="form-row">
                           <div class="form-group floating-label col-md-6 col-sm-12">
                               <label>First Name</label>
                               <input type="text" required class="form-control" placeholder="First Name" v-model="register.firstname">
                           </div>
                           <div class="form-group floating-label col-md-6 col-sm-12">
                               <label>Last Name</label>
                               <input type="text" required class="form-control" placeholder="Last Name" v-model="register.lastname">
                           </div>
                           <div class="form-group floating-label col-md-6">
                               <label>Name of Facility</label>
                               <input type="text" required class="form-control" placeholder="Agency Name" v-model="register.agency_name">
                           </div>

                             <div class="form-group floating-label col-md-6">
                                 <label>Email</label>
                                 <input type="email" required class="form-control" placeholder="Email" v-model="register.email">
                             </div>
                             <div class="form-group floating-label col-md-6">
                                 <label>Phone Number</label>
                                 <input v-phone type="text" required class="form-control" placeholder="Phone Number" v-model="register.phone_number">
                             </div>

                             <div class="form-group floating-label col-md-6">
                                 <input type="text" class="form-control" v-model="register.address1" placeholder="Address">
                             </div>
                       </div>

                       <div class="row">

                         <div class="form-group col-md-6">
                               <select class="form-control"  v-model="register.localgovt">
                                <option value="">Select LGA</option>
                                <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">{{lga.local_name}}</option>
                            </select>
                         </div>



                         <div class="form-group floating-label col-md-6 col-sm-12">
                             <label>Ward</label>
                             <input type="text" required class="form-control" placeholder="Ward" v-model="register.ward">
                         </div>

                         <div class="form-group floating-label col-md-6 col-sm-12">
                             <input type="password" required class="form-control" placeholder="Password" v-model="register.password">
                         </div>
                         <div class="form-group floating-label col-md-6 col-sm-12">
                             <input type="password" required class="form-control" placeholder="Password Confirmation" v-model="register.password_confirmation">
                         </div>

                       </div>

                         <button @click="registerUser" class="btn btn-primary btn-block btn-lg">Add Health Provider</button>

                       </div>
                     </div>

                   </div>



               </div>
           </div>


           <div class="vld-parent">
                <loading :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"></loading>
            </div>

       </section>
    </main>
   </section>
</template>

<script>
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Loading
  },
  data(){
    return{
      user:null,
      providers:"",
      agencies:"",
      edit:false,
      show:false,
      isLoading: false,
      fullPage: true,
      agency_id:"",
      provider_id:"",
      states:"",
      state:"",
      lga_states:"",
      register:{
                firstname:"",
                lastname:"",
                facility_code:"",
                email:"",
                type:"provider",
                phone_number:"",
                state:"",
                agency_name:"",
                ward:"",
                services_offered:"",
                localgovt:"",
                address1:"",
                role:0,
                password:"",
                password_confirmation:""
            }
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))

  },
  methods:{
    fetchLga(){
      this.axios.get(`/api/v1/auth/lga/2683`)
                  .then(response => {
                      this.lga_states = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },

    registerUser(){
        this.isLoading = true;
        this.axios.post('/api/v1/auth/registerProvider',{
          firstname : this.register.firstname,
          lastname : this.register.lastname,
          email : this.register.email,
          phone_number : this.register.phone_number,
          agency_name : this.register.agency_name,
          type : this.register.type,
          state : '2683',
          localgovt : this.register.localgovt,
          // services_offered : this.register.services_offered,
          address1 : this.register.address1,
          ward : this.register.ward,
          enrolled_by : 0,
          role : this.register.role,
          password : this.register.password,
          password_confirmation : this.register.password_confirmation
        })
        .then(response=>{
          let user_id = response.data.data.id

            //add provider
              this.show = false;
              console.log(user_id)
              this.axios.post('/api/v1/auth/providerApply',{
                    provider_id: user_id,
                    agency_id: 4,
                    status: true,
                  })
                  .then(response=>{
                      console.log(response);
                      this.$toasted.info('Facility added Successfully!', {position: 'top-left', duration:3000 })
                      window.location = 'https://www.zamchema.zm.gov.ng';
                  })
                  .catch(error=>{
                      console.log(error.response)
                  })
                  //end of provider

            console.log(response);
            this.isLoading = false;

        })
        .catch(error=>{
            console.log(error.response)
            this.isLoading = false;
            this.$toasted.error('Sign up not Successful', {position: 'top-left', duration:5000 })
        })
    },

  },
  created(){
    this.fetchLga()
  }

}
</script>
